<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-chalkboard-teacher_bk.png" alt width="27.3" height="25.2" />
      <p class="title-bk">先生管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'teacher' : 'home' }">戻る</router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <td colspan="2">
              <button type="button" class="btn btn-edit" @click="edit" v-show="allowEditingTeacher">
                編集
              </button>
              <button type="button" class="btn" @click="changePassword">
                パスワード変更
              </button>
            </td>
          </tr>
          <tr>
            <th scope="row" width="30%">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">先生ID</th>
            <td>{{ currentTeacher.uid }}</td>
          </tr>
          <tr>
            <th scope="row">先生名</th>
            <td>{{ currentTeacher.name }}</td>
          </tr>
          <tr>
            <th scope="row">先生名（フリガナ）</th>
            <td>{{ currentTeacher.nameReading }}</td>
          </tr>
          <tr>
            <th scope="row">生年月</th>
            <td>{{ currentTeacherBirthday }}</td>
          </tr>
          <tr>
            <th scope="row">性別</th>
            <td>{{ currentTeacherGender }}</td>
          </tr>
          <tr>
            <th scope="row">国籍</th>
            <td>{{ currentTeacherNationality }}</td>
          </tr>
          <tr>
            <th scope="row">雇用形態</th>
            <td>{{ currentTeacherEmploymentStatus }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import {
  basicFieldPresent,
  basicBirthday,
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
} from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('teacher/fetchTeacher', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  mounted() {
    // 登録・編集の入力情報を初期化
    this.clearEditingTeacher();
  },
  computed: {
    currentTeacher() {
      return this.teacher.teacher;
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentTeacher.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentTeacher.brand);
    },
    currentTeacherBirthday() {
      return basicBirthday(this.currentTeacher.yearOfBirth, this.currentTeacher.monthOfBirth);
    },
    currentTeacherGender() {
      if (this.currentTeacher.gender) {
        return basicFieldPresent(this.currentTeacher.gender, 'name');
      }
      return basicFieldPresent(this.getGenderById(this.currentTeacher.genderId), 'name');
    },
    currentTeacherEmploymentStatus() {
      if (this.currentTeacher.employmentStatus) {
        return basicFieldPresent(this.currentTeacher.employmentStatus, 'name');
      }
      return basicFieldPresent(this.getEmploymentStatusById(this.currentTeacher.employmentStatusId), 'name');
    },
    currentTeacherNationality() {
      if (this.currentTeacher.nationality) {
        return this.getCountryById(this.currentTeacher.nationality.id).companyjp;
      }
      return basicFieldPresent(this.getCountryById(this.currentTeacher.nationalityId), 'companyjp');
    },
    ...mapState(['teacher']),
    ...mapGetters('country', ['getCountryById']),
    ...mapGetters('gender', ['getGenderById']),
    ...mapGetters('employment_status', ['getEmploymentStatusById']),
    ...mapGetters('role', ['allowEditingTeacher']),
  },
  methods: {
    edit() {
      if (this.id) {
        this.$logger.debug('Edit Teacher ID ' + this.id);
        this.$router.push({ name: 'teacher-id-edit', params: { id: this.id } });
      }
    },
    changePassword() {
      if (this.id) {
        this.$logger.debug('Change Password ID ' + this.id);
        this.$router.push({ name: 'teacher-id-change-password', params: { id: this.id } });
      } else {
        this.$logger.debug('Change Password');
        this.$router.push({ name: 'teacher-change-password' });
      }
    },
    ...mapActions('teacher', ['clearEditingTeacher']),
  },
};
</script>

<style scoped>
.btn {
  margin-left: 0px;
}
.btn-edit {
  margin-right: 20px;
}
</style>
